import axios from 'axios'

const http =  axios.create({
  baseURL: process.env.VUE_APP_API_URL || 'https://staging.api.vitelhealth.com/',
})

http.interceptors.request.use(config => {
  return config;
});

export default http;